<template>
  <div class="main-setting-menu">
    <HeaderMenu
      :arrow="arrow"
      :title="$t('myProfile.disconnectSettings')"
      :routeBackName="routeBackName"
    />
    <div class="item">
      <div class="bold mrg-b-3">
        {{ $t("disconnectSettings.disconnectAfter") }}
      </div>
      <div style="padding-top:10px">
        <input
          style="width:50px"
          v-select.focus
          @keyup.enter="openBookInRealWin"
          class="input-border"
          :value="disconnectMinutes"
          @input="dirty = true"
          ref="disconnectMinutesInput"
        />
      </div>
      <div class="bold mrg-b-3">{{ $t("disconnectSettings.noUse") }}</div>
      <div class="flex flex-bet" style="padding-top: 20px;">
        <div
          class="btn btn-larg"
          @click="setDisconnectedMinutes()"
          :class="{ disable: !dirty }"
        >
          {{ $t("general.saveChanges") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateUserExtraInfo } from "@/services/login";
import onlineHelper from "@/services/onlineStations";
export default {
  data() {
    return {
      routeBackName: "myProfile",
      dirty: false,
    };
  },
  props: {
    arrow: { default: true },
  },
  computed: {
    disconnectMinutes() {
      return this.$store.state.user.extraInfo?.idleminutes || 20;
    },
  },
  methods: {
    /* setDisconnectMinutes(e) {
      try {
        this.$store.state.user.extraInfo?.idleminutes = parseInt(
          e.target.value
        );
      } catch (ex) {
        console.log(ex);
        this.$store.state.user.extraInfo?.idleminutes = 20;
      }
    }, */
    async setDisconnectedMinutes() {
      if (this.$store.state.user.extraInfo) {
        try {
          this.$store.state.user.extraInfo.idleminutes = parseInt(
            this.$refs.disconnectMinutesInput.value
          );
          if (await updateUserExtraInfo(this.$store.state.user.extraInfo)) {
            //set extra info in state

            //set onlineTimer
            onlineHelper.startOnlineTimer();
          } else {
            alert("error" + ex.message);
          }
          this.dirty = false;
        } catch (ex) {
          console.log(ex);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  padding: 20px;
}
</style>
